
import React, { Component } from 'react';
import { Grid, Icon, Modal, Button } from 'semantic-ui-react';
import VirtualizedSelect from 'react-virtualized-select'
import 'react-select/dist/react-select.css';
import '../../css/virtual-select.css';
import { Markdown } from 'react-showdown';
import { getDashBoardDetails } from './../utils/rest';

class CorporateDropdown extends Component {
    constructor(props) {
        super(props);
        this.state = {
            corporate: this.props.currentCorporate,
            open: false,
            markdown: ''
        }
        if (this.props.corporate && this.props.corporate.length > 0) {
            let corporateClient = [];
            if (this.props.currentCorporate > 0) {
                corporateClient = this.props.corporate.filter((crp) => {
                    return crp.value.toString() === this.props.currentCorporate.toString();
                });
            } if (corporateClient.length === 0) {
                corporateClient = this.props.corporate;
            }
            this.props.addItem("clients", corporateClient[0].clients.map((client, index) => ({
                key: index,
                value: client.id,
                text: client.name,
                allowedtopostpayment: this.props._ifNull(client.allowedToPostPayment, 1) ? 1 : 0,
                allowedtocreateaccount: this.props._ifNull(client.allowedToCreateAccount, 1) ? 1 : 0,
                allowedtoholdaccount: this.props._ifNull(client.allowedToHoldAccount, 1) ? 1 : 0,
                allowedtocancelaccount: this.props._ifNull(client.allowedToCancelAccount, 1) ? 1 : 0,
                allowedtoviewreport: this.props._ifNull(client.allowedToViewReport, 1) ? 1 : 0
                //  label: client.name,
            })));
        }
    }

    close = () => {
        this.setState((prevState, props) => {
            return { open: false };
        });
    }

    open = () => {
        if (this.props.items.helpFile !== null) {
            const helpFile = require("../../docs/" + this.props.items.helpFile);
            fetch(helpFile)
                .then(response => {
                    return response.text();
                }).then(text => {
                    this.setState({
                        markdown: text,
                        open: true
                    })
                });
        }
    }

    resetClients = (e) => {
        if (e !== null) {
            this.setState({
                corporate: e.value
            }, () => this.props.addItem("currentCorporate", e.value));
            if (e.clients.length > 0) {
                this.props.addItem("clients", e.clients.map((client, index) => ({
                    key: index,
                    value: client.id,
                    text: client.name,
                    allowedtopostpayment: this.props._ifNull(client.allowedToPostPayment, 1) ? 1 : 0,
                    allowedtocreateaccount: this.props._ifNull(client.allowedToCreateAccount, 1) ? 1 : 0,
                    allowedtoholdaccount: this.props._ifNull(client.allowedToHoldAccount, 1) ? 1 : 0,
                    allowedtocancelaccount: this.props._ifNull(client.allowedToCancelAccount, 1) ? 1 : 0,
                    allowedtoviewreport: this.props._ifNull(client.allowedToViewReport, 1) ? 1 : 0
                    //     label: client.name,
                })));
                getDashBoardDetails(e.value).then((response) => {
                    if (response !== null && (response instanceof Object)) {
                        this.props.addItem("countDetails", response);
                    }
                })
            }
            //sessionStorage.setItem("selectedCorporate", e.value);
            localStorage.setItem("selectedCorporate", e.value);
        }
    };

    render() {

        const corporateDropdown = () => {
            return (
                <VirtualizedSelect
                    options={this.props.corporate}
                    placeholder='Select Parent / Corporate'
                    onChange={this.resetClients}
                    value={this.state.corporate}
                    name="corporate"
                />
            )
        }
        const helpFile = () => {
            return (
                <div className="margin-icon-bch">
                    <div className="ui circular right floated ui icon tiny button" type="button" id="helplink" onClick={this.open} data-markdowndoc="docs/am_inquiry.md"><Icon name="info" /></div>
                </div>
            )
        }
        return (
            <Grid style={{ position: "relative", width: "100%" }}>
                <Grid.Row style={{ position: "absolute", padding: "0px", top: "-3px", right: "-42px", zIndex: 9 }}>
                    <Grid.Column width={10} />
                    <Grid.Column width={5} style={{ padding: "0px" }}>
                        {this.props.items.corporateSelect ? corporateDropdown() : <div />}
                    </Grid.Column>
                    <Grid.Column>
                        {this.props.items.helpFile ? helpFile() : <div />}
                    </Grid.Column>
                    <Modal size="large" open={this.state.open} onClose={this.close}>
                        <Modal.Content scrolling>
                            <Markdown markup={this.state.markdown} />
                        </Modal.Content>
                        <Modal.Actions>
                            <Button.Group width={2} className="small buttons push-down">
                                <Button onClick={this.close}>{this.props.t("close")}</Button>
                            </Button.Group>
                        </Modal.Actions>
                    </Modal>
                </Grid.Row>
            </Grid>
        )
    }
}

export default CorporateDropdown;


// WEBPACK FOOTER //
// ./src/app/components/CorporateDropdown.js